import { selectAutoPlayReady, selectIsIdle } from '../../selectors/player';

const shouldShowPlayer = (state) =>
  !selectIsIdle(state) || selectAutoPlayReady(state);

export default shouldShowPlayer;
